import { render, staticRenderFns } from "./EventHighlightsTab.vue?vue&type=template&id=5e13d1a9"
import script from "./EventHighlightsTab.vue?vue&type=script&lang=ts"
export * from "./EventHighlightsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports